import * as React from 'react';
import { CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '../FontAwesomeIcon';

interface IContentCardHeaderProps {
  header?: string | JSX.Element;
  color?: string;
  borderBottom?: boolean;
  className?: string;
  sticky?: boolean;
  loading?: boolean;
  headerActions?: JSX.Element;
  style?: React.CSSProperties;
}

export class ContentCardHeader extends React.Component<IContentCardHeaderProps, {}> {
  render() {
    const { sticky, headerActions, className, borderBottom, header, loading } = this.props;
    const { color = 'white' } = this.props;
    const headerClassNames = [`bg-${color}`]
    const loadingIcon = (<FontAwesomeIcon icon="cog" size="sm" verticalAlign="middle" spin={true} muted />)

    if (className) {
      headerClassNames.push(className)
    }

    if (borderBottom) {
      headerClassNames.push('table-border-bottom');
    }

    if (sticky) {
      headerClassNames.push('sticky-top')
    }

    return (
      <CardBody className={headerClassNames.join(' ')} style={this.props.style}>
        {header &&
          <h2 className="mb-0">
            {this.props.header}
            {loading &&
              <>&nbsp;{loadingIcon}</>
            }
          </h2>
        }
        {!header && loading && loadingIcon}
        {headerActions &&
          <section>{headerActions}</section>
        }
      </CardBody>
    )
  }
}
